import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { useAuthProvider } from './AuthProvider.hook'
import routes from '../../../../config/settings/routes'
import LoginLoading from '../../../../components/Spinners/LoginLoading'

const ProtectedByAuthentication = () => {
  const { isAuthenticated, initialLoading } = useAuthProvider()

  if (initialLoading || isAuthenticated === undefined) {
    return <LoginLoading message="Iniciando sesión..." />
  }

  if (!isAuthenticated) {
    return <Navigate to={routes.login} replace />
  }

  return <Outlet />
}

export default ProtectedByAuthentication
